import React from "react";
import styled from "styled-components";
import * as StringUtil from "@lifeat/shared/util/StringUtil";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import { lightTheme } from "@themes/Theme";

const AviWrapper = styled.div<{ size: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${(props) => props.size};
    width: ${(props) => props.size};
    border-radius: 50%;
`;

const AviImg = styled.img<{ size: string }>`
    border-radius: 50%;
    height: ${(props) => props.size};
    width: ${(props) => props.size};
`;

const PlaceholderAviImg = styled.div<{ size: string; colorHex: string }>`
    border-radius: 50%;
    height: ${(props) => props.size};
    width: ${(props) => props.size};
    background: ${(props) => props.colorHex};
`;

const AviInitial = styled.div`
    position: absolute;
    color: ${lightTheme.textColorPrimary};
    font-size: ${FontSize.normal};
`;

const PLACEHOLDER_AVI_BACKGROUND_COLORS = [
    Styles.userAviColors.blue,
    Styles.userAviColors.pink,
    Styles.userAviColors.yellow,
    Styles.userAviColors.purple,
    Styles.userAviColors.grey,
    Styles.userAviColors.green,
];

type UserAvatarSizeType = "small" | "medium" | "large";
interface UserAvatarProps {
    readonly size: UserAvatarSizeType;
    readonly userDisplayName: string;
    /**
     * If not provided, a default element will be shown with the user's first initial.
     */
    readonly userAviUrl?: string | undefined;
    className?: string;
}
function UserAvatar(props: UserAvatarProps) {
    return (
        <AviWrapper size={getSizePx(props.size)}>
            {props.userAviUrl?.length > 0 && <AviImg src={props.userAviUrl} size={getSizePx(props.size)} />}
            {!(props.userAviUrl || props.userAviUrl?.length > 0) && (
                <>
                    <PlaceholderAviImg size={getSizePx(props.size)} colorHex={getRandomColor(props.userDisplayName)} />
                    <AviInitial>{props.userDisplayName[0]}</AviInitial>
                </>
            )}
        </AviWrapper>
    );
}

const getRandomColor = (name?: string): string => {
    if (StringUtil.isValidString(name)) {
        // get the color index based on the name's last letter
        const idx = name.charCodeAt(name.length - 1) % PLACEHOLDER_AVI_BACKGROUND_COLORS.length;
        return PLACEHOLDER_AVI_BACKGROUND_COLORS[idx];
    } else {
        const randIdx = Math.floor(Math.random() * (PLACEHOLDER_AVI_BACKGROUND_COLORS.length - 1));
        return PLACEHOLDER_AVI_BACKGROUND_COLORS[randIdx];
    }
};

const getSizePx = (size: UserAvatarSizeType) => {
    switch (size) {
        case "small": {
            return "30px";
        }
        case "medium": {
            return "45px";
        }
        case "large": {
            return "60px";
        }
        default: {
            return "30px";
        }
    }
};

export default UserAvatar;
